import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/reportesbi',
  documento: 'reportesbi',
  acceso: 'sesion',
  filas: ['114'],
  cita: 'Areas/ReportesBI/Controllers/DashboardController.cs',
} satisfies RutaProd;
